import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiPlus, FiX } from 'react-icons/fi';
import Navbar from '../Customer/Navbar';

const FixedDepositProducts = () => {
  const navigate = useNavigate();

  const allProducts = [
    {
      id: 1,
      name: 'Senior Citizen FD',
      company: 'HDFC Bank',
      icon: '👴',
      description: 'Special fixed deposit scheme for senior citizens with higher interest rates',
      features: ['Higher Interest Rate', 'Tax Benefits', 'Flexible Tenure', 'Easy Withdrawal'],
      minPremium: '₹1,000',
      maxCoverage: 'Unlimited',
      tenure: '1-10 years',
      purchased: true,
      policyNumber: 'FD-2025-001',
      purchaseDate: '2025-01-10',
      amount: '100000.00'
    },
    {
      id: 2,
      name: 'Regular FD',
      company: 'ICICI Bank',
      icon: '💳',
      description: 'Standard fixed deposit with competitive interest rates and safety',
      features: ['Competitive Rates', 'Safe Investment', 'Flexible Tenure', 'Online Management'],
      minPremium: '₹500',
      maxCoverage: 'Unlimited',
      tenure: '7 days - 10 years',
      purchased: false
    },
    {
      id: 3,
      name: 'Tax Saving FD',
      company: 'Axis Bank',
      icon: '📋',
      description: 'Tax-saving fixed deposit with Section 80C benefits',
      features: ['Tax Deduction', 'Lock-in Period', 'Higher Returns', 'Guaranteed Returns'],
      minPremium: '₹1,000',
      maxCoverage: 'Unlimited',
      tenure: '5 years',
      purchased: false
    },
    {
      id: 4,
      name: 'Sweep FD',
      company: 'SBI',
      icon: '🔄',
      description: 'Automatic sweep facility that converts savings into fixed deposits',
      features: ['Auto Sweep', 'Better Returns', 'Flexible Amount', 'Easy Access'],
      minPremium: '₹1,000',
      maxCoverage: 'Unlimited',
      tenure: 'Flexible',
      purchased: false
    }
  ];

  const purchasedProducts = allProducts.filter(p => p.purchased);
  const availableProducts = allProducts.filter(p => !p.purchased);

  const ProductCard = ({ product, isPurchased }) => (
    <div
      className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow border-l-4"
      style={{borderColor: '#305daa'}}
    >
      <div className="text-6xl mb-4">{product.icon}</div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">{product.name}</h2>
      <p className="text-sm font-semibold mb-3" style={{color: '#305daa'}}>
        {product.company}
      </p>
      <p className="text-gray-600 mb-4">{product.description}</p>

      <div className="mb-4">
        <p className="text-sm font-semibold text-gray-700 mb-2">Key Features:</p>
        <div className="flex flex-wrap gap-2">
          {product.features.map((feature, idx) => (
            <span
              key={idx}
              className="text-xs px-3 py-1 rounded-full bg-gray-100 text-gray-700"
            >
              {feature}
            </span>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6 py-4 border-t border-b border-gray-200">
        <div>
          <p className="text-xs text-gray-600">Min Deposit</p>
          <p className="font-semibold text-gray-900">{product.minPremium}</p>
        </div>
        <div>
          <p className="text-xs text-gray-600">Max Deposit</p>
          <p className="font-semibold text-gray-900">{product.maxCoverage}</p>
        </div>
        <div>
          <p className="text-xs text-gray-600">Tenure</p>
          <p className="font-semibold text-gray-900">{product.tenure}</p>
        </div>
      </div>

      {isPurchased ? (
        <div className="space-y-3">
          <div className="bg-blue-50 p-3 rounded-lg">
            <p className="text-xs text-gray-600">Policy Number</p>
            <p className="font-semibold text-gray-900">{product.policyNumber}</p>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-blue-50 p-3 rounded-lg">
              <p className="text-xs text-gray-600">Purchase Date</p>
              <p className="font-semibold text-gray-900">{new Date(product.purchaseDate).toLocaleDateString()}</p>
            </div>
            <div className="bg-blue-50 p-3 rounded-lg">
              <p className="text-xs text-gray-600">Amount</p>
              <p className="font-semibold" style={{color: '#305daa'}}>₹{parseFloat(product.amount).toLocaleString('en-IN')}</p>
            </div>
          </div>
          <button
            className="w-full text-white py-2 rounded-lg hover:opacity-90 font-medium flex items-center justify-center gap-2"
            style={{backgroundColor: '#305daa'}}
          >
            <FiX /> Remove
          </button>
        </div>
      ) : (
        <button
          className="w-full text-white py-2 rounded-lg hover:opacity-90 font-medium flex items-center justify-center gap-2"
          style={{backgroundColor: '#305daa'}}
        >
          <FiPlus /> Add to Portfolio
        </button>
      )}
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar customerName="Test Customer" />

      <div className="py-8 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="mb-8 pt-12">
            <button
              onClick={() => navigate('/customer-profile')}
              className="flex items-center gap-2 text-white px-4 py-2 rounded-lg hover:opacity-90 mb-6"
              style={{backgroundColor: '#305daa'}}
            >
              <FiArrowLeft /> Back
            </button>

            <div className="text-white rounded-lg shadow-md p-8" style={{backgroundColor: '#305daa'}}>
              <h1 className="text-4xl font-bold mb-2">Fixed Deposit Products</h1>
              <p className="opacity-80">Explore our fixed deposit schemes with guaranteed returns</p>
            </div>
          </div>

          {/* Purchased Products Section */}
          {purchasedProducts.length > 0 && (
            <div className="mb-12">
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Your Purchased Products</h2>
                <p className="text-gray-600">Products you have already purchased from Infrec</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {purchasedProducts.map((product) => (
                  <ProductCard key={product.id} product={product} isPurchased={true} />
                ))}
              </div>
            </div>
          )}

          {/* Available Products Section */}
          {availableProducts.length > 0 && (
            <div>
              <div className="mb-6">
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Available Products</h2>
                <p className="text-gray-600">Explore more fixed deposit products to add to your portfolio</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {availableProducts.map((product) => (
                  <ProductCard key={product.id} product={product} isPurchased={false} />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FixedDepositProducts;
